import ReactPlayer from "react-player";
export default function CustomReactPlayer(props) {
  return (
    <div
      style={{ width: props?.width, height: props?.height, ...props?.style }}
    >
      <ReactPlayer
        className="custom-react-player"
        url={props?.url || ""}
        controls={props.controls || false}
        playing={props?.playing || false}
        muted={props?.muted || false}
        height={"100%"}
        width={"100%"}
        onClick={props?.onClick}
      />
    </div>
  );
}